import React from "react";

export function LegalPage({ title, kicker, children }) {
  return (
    <div className="bg-[#FAFAF8]" data-testid="legal-page">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
        {kicker && (
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="h-px w-6 bg-[#A7B584]" />
            <span className="uppercase tracking-[0.18em] text-xs font-semibold text-[#5A5B5C]">
              {kicker}
            </span>
          </div>
        )}
        <h1 className="text-4xl sm:text-5xl font-semibold text-[#5A5B5C] tracking-tight leading-[1.05]">
          {title}
        </h1>
        <div className="legal-prose mt-12 text-[#272525] leading-relaxed">
          {children}
        </div>
      </div>
    </div>
  );
}

export function H2({ children, id }) {
  return (
    <h2
      id={id}
      className="mt-12 mb-4 text-2xl sm:text-3xl font-semibold text-[#5A5B5C] tracking-tight scroll-mt-20"
    >
      {children}
    </h2>
  );
}

export function H3({ children, id }) {
  return (
    <h3
      id={id}
      className="mt-8 mb-3 text-lg sm:text-xl font-semibold text-[#5A5B5C] scroll-mt-20"
    >
      {children}
    </h3>
  );
}

export function P({ children }) {
  return <p className="mt-3 text-[15px] sm:text-base leading-relaxed">{children}</p>;
}

export function UL({ children }) {
  return (
    <ul className="mt-3 space-y-2 list-disc pl-6 text-[15px] sm:text-base leading-relaxed marker:text-[#A7B584]">
      {children}
    </ul>
  );
}

export function Address({ children }) {
  return (
    <address className="not-italic mt-3 leading-relaxed text-[15px] sm:text-base text-[#272525]">
      {children}
    </address>
  );
}

export function Note({ children }) {
  return (
    <div className="mt-6 rounded-xl border border-[#EAEBE6] bg-white p-5 text-sm text-[#5A5B5C] leading-relaxed">
      {children}
    </div>
  );
}
